export default __webpack_public_path__ + "static/germ-f0acda182ab1fe0219bcfdede7c0e574.jpg";